// reach component 
import React from 'react';
import './App.css';
import './index.css';
import microphone from './resources/microphone.svg'
import backstage from './resources/backstage.svg'
import billboard from './resources/billboard.svg'
import sales from './resources/sales.svg'

function MetroIconLauncher() {

    return (
        <div className="m-3">
            <div className="grid grid-cols-3 gap-4">
                    <div className="p-6 max-w-sm mx-auto bg-white rounded-xl shadow-lg flex items-center space-x-4">
                        <div>
                            <img src={microphone} className="h-12 w-12" alt="WebVT" />
                        </div>
                        <div>
                            <div className="text-xl font-medium text-black">WebVT</div>
                        </div>
                    </div>
                    <div className="p-6 max-w-sm mx-auto bg-white rounded-xl shadow-lg flex items-center space-x-4">
                        <div>
                            <img src={backstage} className="h-12 w-12" alt="Backstage" />
                        </div>
                        <div>
                            <div className="text-xl font-medium text-black">Backstage</div>
                        </div>
                    </div>
                    <div className="p-6 max-w-sm mx-auto bg-white rounded-xl shadow-lg flex items-center space-x-4">
                        <div>
                            <img src={billboard} className="h-12 w-12" alt="Billboard" />
                        </div>
                        <div>
                            <div className="text-xl font-medium text-black">Billboard</div>
                        </div>
                    </div>
                    <div className="p-6 max-w-sm mx-auto bg-white rounded-xl shadow-lg flex items-center space-x-4">
                        <div>
                            <img src={sales} className="h-12 w-12" alt="Sales" />
                        </div>
                        <div>
                            <div className="text-xl font-medium text-black">Sales</div>
                        </div>
                    </div>
            </div>
        </div>
    );
};

export default MetroIconLauncher;
